import React, { useState } from "react"
import { spacedNum } from "../../../common/CommonHelper"
import { IErrorModel } from "../../../../types/error/IErrorModel"
import { ModalPopUp } from "../../../common/element/ModalPopUp"
import { IModalMessage } from "../../../../types/error/IModalMessage"
import { CommonFileInput } from "../../../common/element/fields/CommonFileInput"
import { CommonFileList } from "../../../common/element/fields/CommonFileList"
import { ICurrencyReplenishmentDto } from "@/types/replenishment/ICurrencyReplenishmentDto"

export const PaymentTab: React.FC<{
  replenishment: ICurrencyReplenishmentDto
  setReplenishment: (r: ICurrencyReplenishmentDto) => void
  errorModel: IErrorModel | undefined
  sending: boolean
  submit: () => void
  reject: () => void
}> = ({ replenishment, setReplenishment, errorModel, submit, reject }) => {
  const [message, setMessage] = useState<IModalMessage | null>(null)

  const doSubmit = () => {
    if (!replenishment.slips || replenishment.slips.length === 0) {
      setMessage({ title: "Ошибка!", text: "Загрузите платежные поручения" })
      return
    }

    submit()
  }

  if (replenishment.status === "SLIP_SENT") {
    return (
      <div className="container">
        <div className="container-pop-up">
          <ul className="form-left">
            <li className="form-block-popup">
              <h4 className="heading-chapter">Документы отправлены!</h4>
              <p className="message-course-yes">
                Ваши документы успешно отправлены и находятся на проверке у менеджера. Это может занять некоторое время.
                В случае успешной проверки вы сможете продолжить оформление. В противном случае будет необходимо внести
                исправления в соответствии с комментариями менеджера
              </p>
            </li>
          </ul>
        </div>
      </div>
    )
  } else {
    return (
      <>
        <ModalPopUp message={message} close={() => setMessage(null)} />
        <div className="container">
          <div className="container-pop-up">
            {replenishment.status === "SLIP_SENT" && (
              <p className="message-course-yes">
                Платежные поручения отправлены. После проверки менеджер произведет фиксацию курса и ваш баланс будет
                пополнен
              </p>
            )}
            <ul className="form-left">
              <div className="course-apply_block width-full">
                <div className="replenishment__payment-grid width-full">
                  <li className="form-block-popup justifyBetween">
                    <h4 className="heading-chapter">Сумма пополнения</h4>
                    <p className="valute-deal-user--small">{spacedNum(Number(replenishment.invoiceAmount) / 100)}</p>
                  </li>
                  <li className="form-block-popup justifyBetween">
                    <h4 className="heading-chapter">Валюта пополнения</h4>
                    <p className="valute-deal-user--small">{replenishment.currencyRequest?.currency}</p>
                  </li>
                </div>
                <ul className="course-flex-block flex-wrap">
                  <li className="course-status-block">
                    <p className="course-summ-rub-percent">
                      <span>Пополнение счета</span>
                      Пополнение №{replenishment.id}
                    </p>
                  </li>
                </ul>
                <div className="flex-row-10">
                  <button
                    className="btn black-btn"
                    onClick={() => window.open(`/currency-replenishment/${replenishment.id}/bill`)}
                  >
                    Открыть счет
                  </button>
                </div>
              </div>
            </ul>

            <div className="right-form">
              <div className="form-block-popup">
                {replenishment.status === "NEW" ? (
                  <>
                    <h4 className="heading-chapter">Платежные поручения</h4>
                    <CommonFileInput
                      label={"Документы"}
                      placeholder={replenishment.slips && replenishment.slips?.length > 0 ? "Заменить" : "Загрузить"}
                      name={"slips"}
                      errorModel={errorModel}
                      multiple={true}
                      _callback={f => void 0}
                      _callbackMultiple={f =>
                        setReplenishment({
                          ...replenishment,
                          slips: f
                        })
                      }
                    />
                    <CommonFileList files={replenishment.slips} />
                  </>
                ) : (
                  <h4 className="heading-chapter">Платежные поручения загружены</h4>
                )}
              </div>
            </div>
            {replenishment.status === "NEW" ? (
              <div className="flex-row-10 flex-wrap">
                <button className="btn" onClick={doSubmit}>
                  Подтвердить
                </button>
                {/* <button
                  className="btn black-btn"
                  onClick={() => (showEdit ? window.location.reload() : showShowEdit())}
                >
                  {showEdit ? "Вернуть как было" : "Редактировать данные"}
                </button> */}
                {/* <button className="btn grey-btn" onClick={reject}>
                  Отменить оплату
                </button> */}
              </div>
            ) : (
              <></>
            )}
          </div>
        </div>
      </>
    )
  }
}
